import { useState, useEffect } from 'react';

import { sanitizeString } from '../../utils/sanitizeString';

const useSessionStorage = (key, initValue) => {
  try {
    const hasSessionStorage = !!window?.sessionStorage?.getItem && !!window?.sessionStorage?.setItem;
    const [storedValue, setStoredValue] = useState(() => {
      /* istanbul ignore else */
      if (!hasSessionStorage || typeof key === 'undefined') {
        return initValue;
      }
      try {
        const cachedValue = JSON.parse(window.sessionStorage.getItem(key));
        return cachedValue === null ? initValue : cachedValue;
      } catch (err) /* istanbul ignore next */ {
        return initValue;
      }
    });
    useEffect(() => {
      if (hasSessionStorage && storedValue) {
        window.sessionStorage.setItem(key, sanitizeString(JSON.stringify(storedValue)));
      }
    }, [key, storedValue]);

    return [storedValue, setStoredValue];
  } catch (error) {
    return [0, () => {}];
  }
};

export default useSessionStorage;
